import React from "react";
import PrimaryHeading from "components/heading/PrimaryHeading";
import SecondaryHeading from "components/heading/SecondaryHeading";
import AddBoardGame from "./componets/addBoardGame";
import TableBoardGame from "./componets/tableBoardGame";
import Loading from "components/loading";
import useAxiosInstance from "../../../axiosInstance";
import { toast } from "react-toastify";

const BoardGame = () => {
  const [data, setData] = React.useState([]);
  const axiosInstance = useAxiosInstance();
  const [isLoading, setIsLoading] = React.useState(false);

  // React.useEffect(() => {
  //   setIsLoading(true);
  //   axiosInstance
  //     .get("/boardgames/all")
  //     .then((res) => {
  //       setData(res.data);
  //       //toast.success('Data loaded Successfully!')
  //       //console.log(res.data)

  //       setIsLoading(false);
  //     })
  //     .catch((err) => {
  //       toast.error("Something went Wrong!");

  //       setIsLoading(false);
  //     });
  // }, []);

  if (isLoading === true) {
    return (
      <div className="flex h-screen flex-col items-center justify-center">
        <div className="flex items-center justify-center">
          <Loading />
        </div>
      </div>
    );
  }

  return (
    <div>
      <PrimaryHeading title={"Add Board Game"} />
      <AddBoardGame />
      <SecondaryHeading title={"Board Games"} />
      <TableBoardGame />
    </div>
  );
};

export default BoardGame;
